import { getType } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import { IAuth, IOAuthApi } from '../../interfaces';
import { convertToError } from '../../utils';
import * as actions from './actions';

function* login(api: IOAuthApi, action: ReturnType<typeof actions.login>) {
  const { credentials } = action.payload;

  try {
    const auth: IAuth = yield call(api.login, credentials);

    yield put(actions.loginSucceeded({ auth, credentials }));
  } catch (e) {
    yield put(actions.loginFailed(convertToError(e)));
  }
}

function* forgotPassword(api: IOAuthApi, action: ReturnType<typeof actions.forgotPassword>) {
  const { email } = action.payload;

  try {
    yield call(api.forgotPassword, email);

    yield put(actions.forgotPasswordSucceeded());
  } catch (e) {
    yield put(actions.forgotPasswordFailed(convertToError(e)));
  }
}

function* register(api: IOAuthApi, action: ReturnType<typeof actions.register>) {
  const { credentials } = action.payload;

  try {
    yield call(api.register, credentials);

    yield put(actions.registerSucceeded());
  } catch (e) {
    yield put(actions.registerFailed(convertToError(e)));
  }
}

function* checkEmailInDatabase(api: IOAuthApi, action: ReturnType<typeof actions.checkEmailInDatabase>) {
  const { email } = action.payload;

  try {
    yield call(api.checkEmailInDatabase, email);

    yield put(actions.checkEmailInDatabaseSucceeded());
  } catch (e) {
    yield put(actions.checkEmailInDatabaseFailed(convertToError(e)));
  }
}

function* logout(api: IOAuthApi) {
  try {
    yield call(api.logout);

    yield put(actions.logoutSucceeded());
  } catch (e) {
    yield put(actions.logoutFailed(convertToError(e)));
  }
}

export function* authSaga(api: IOAuthApi) {
  yield takeLatest(getType(actions.login), login, api);
  yield takeLatest(getType(actions.forgotPassword), forgotPassword, api);
  yield takeLatest(getType(actions.register), register, api);
  yield takeLatest(getType(actions.checkEmailInDatabase), checkEmailInDatabase, api);
  yield takeLatest(getType(actions.logout), logout, api);
}
